import _logoWhite from "@/assets/stm-logo-white.png.asset.json";
import _logoNavy from "@/assets/stm-logo-navy.png.asset.json";
import _emailHeader from "@/assets/stm-email-header.png.asset.json";

export type AssetInfo = {
  url: string;
  alt?: string;
  original_filename?: string;
  content_type?: string;
};

const logoWhite: AssetInfo = { ..._logoWhite };
const logoNavy: AssetInfo = { ..._logoNavy };
const emailHeader: AssetInfo = { ..._emailHeader };

export function getLogoWhite(): AssetInfo {
  return logoWhite;
}

export function getLogoNavy(): AssetInfo {
  return logoNavy;
}

export function getEmailHeader(): AssetInfo {
  return emailHeader;
}
